import { useLocation } from "react-router-dom";

const CartItem = ({ children }) => {
  const location = useLocation();
  return (
    <div
      className={`w-full md:w-cartWidth bg-white border h-fit ${
        location.pathname === "/cart" ? "mt-3" : "mt-5"
      } p-5`}
    >
      {children}
    </div>
  );
};

export default CartItem;
